import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'EN', flag: '🇺🇸' },
    { code: 'pt', name: 'PT', flag: '🇧🇷' },
    { code: 'es', name: 'ES', flag: '🇪🇸' },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <div className="relative group">
      <motion.button
        className="flex items-center space-x-1.5 text-gray-400 hover:text-gray-200 transition-colors duration-200 px-2 py-1.5 rounded-md"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        aria-label="Change language"
      >
        <Globe className="w-4 h-4" />
        <span className="hidden md:inline text-sm font-medium">{currentLanguage.name}</span>
        <span className="md:hidden text-sm">{currentLanguage.flag}</span>
      </motion.button>

      {/* Dropdown menu */}
      <div className="absolute right-0 mt-1.5 w-28 bg-gray-900/95 backdrop-blur-md rounded-lg shadow-2xl border border-gray-700/50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 overflow-hidden">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`w-full text-left px-3 py-2 flex items-center space-x-2 hover:bg-gray-800/50 transition-colors duration-150 text-sm ${
              i18n.language === lang.code ? 'bg-blue-500/10 text-blue-400 border-l-2 border-blue-500' : 'text-gray-300'
            }`}
          >
            <span className="text-base">{lang.flag}</span>
            <span className="font-medium">{lang.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;

